import React from 'react';
import { trackAddToCart } from './MetaPixel';
interface CtaButtonProps {
  text: string;
  className?: string;
}
export function CtaButton({
  text,
  className = ''
}: CtaButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    trackAddToCart();
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <a href="#pricing" onClick={handleClick} className={`
        inline-block w-full sm:w-auto text-center
        bg-gradient-to-b from-yellow-300 to-yellow-500 
        hover:from-yellow-400 hover:to-yellow-600
        active:scale-95
        text-black font-black text-sm sm:text-base md:text-lg 
        py-3 px-5 sm:px-8 rounded-full 
        shadow-[0_6px_14px_rgba(234,179,8,0.25)] 
        border-b-[3px] border-yellow-600
        transition-all duration-200
        uppercase tracking-wide
        ${className}
      `} data-id="element-43">
      {text}
    </a>;
}